import { observable, action } from 'mobx';

import { Section, UserProfile } from '../models';
import { MarkersOutsideOptimalDisplay } from '../models/UserProfile';
import { LoadingStore } from './loading-store';
import { UserProfileStore } from './user-profile-store';

export class UserProfileUIStore {
  @observable currentUserProfile: UserProfile;
  @observable logoUpdateTrigger: number = 0; // Trigger for logo updates

  constructor(
    private userProfileStore: UserProfileStore,
    private loadingStore: LoadingStore,
  ) {}

  @action loadCurrentUserProfile = async (): Promise<UserProfile> => {
    this.loadingStore.appIsBusy();

    this.currentUserProfile =
      await this.userProfileStore.loadCurrentUserProfile();

    this.loadingStore.appIsNotBusy();

    return this.currentUserProfile;
  };

  @action saveCurrentUserProfile = async (): Promise<UserProfile> => {
    this.loadingStore.appIsBusy();

    this.currentUserProfile = await this.userProfileStore.updateUserProfile(
      this.currentUserProfile,
    );

    this.loadingStore.appIsNotBusy();

    return this.currentUserProfile;
  };

  @action updateLogo = (logoUrl: string): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.customLogoUrl = logoUrl;
      this.logoUpdateTrigger = Date.now(); // Trigger re-render
    }
  };

  @action removeLogo = (): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.customLogoUrl = '';
      this.logoUpdateTrigger = Date.now(); // Trigger re-render
    }
  };

  @action updatePreparedBy = (value: string): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.preparedBy = value;
    }
  };

  @action updateEnabledSupplementBrands = (brands: string[]): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.enabledSupplementBrands = brands;
    }
  };

  @action updateExcludedFromPdfSections = (sections: Section[]): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.excludedFromPdfSections = sections;
    }
  };

  @action updateMarkersOutsideOptimalDisplay = (mode: MarkersOutsideOptimalDisplay): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.markersOutsideOptimalDisplay = mode;
    }
  };

  @action updateShowOnlySectionSignals = (value: boolean): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.showOnlySectionSignals = value;
    }
  };

  @action updateShowOnlyImmuneSectionSignals = (value: boolean): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.showOnlyImmuneSectionSignals = value;
    }
  };

  @action updateShowImmuneAbsolutes = (value: boolean): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.showImmuneAbsolutes = value;
    }
  };

  @action updateComparisonMatchAnalysisOrder = (value: boolean): void => {
    if (this.currentUserProfile) {
      this.currentUserProfile.comparisonMatchAnalysisOrder = value;
    }
  };
}
